import { get, post } from './axiosHelper';
import challengerEnv from '../lib/challengerEnv';
import {
  IContactRequest,
  ICustomerData,
  ICustomerProfile,
  IAddress,
  ICustomerProfileResponse,
  IInvestor,
} from './Icustomer';
const customerManagementPath = 'external/customer-management/v1/api'
enum addressType {
  residentialAddress = 'address',
  postalAddress = 'postAddress',
}
enum InvestorType {
  personalInvestor = 'P',
  institutionalInvestor = 'I',
}

const nullValueString: string = 'Not provided';

const contactRequest = async (data: IContactRequest) => {
  if (challengerEnv().mockApiResponses) {
    return getMockResponse(
      require('../../cypress/fixtures/customer/mock-contact-request-success.json')
    );
  }
  const url = `${challengerEnv().apiBaseUrl}/${customerManagementPath}/contactRequest`;
  return await post(url, data);
};

const combinedAddress = (adr: IAddress, type: addressType) => {
  if (!adr.addressLine1) {
    return nullValueString;
  }
  const addressLine2 = adr.addressLine2 ? ` ${adr.addressLine2},` : '';
  const addressLine3 = adr.addressLine3 ? ` ${adr.addressLine3},` : '';
  let address = `${adr.addressLine1},${addressLine2}${addressLine3} ${adr.suburb} ${adr.state} ${adr.postCode}`;
  if (adr.countryCode && adr.countryCode !== 'AUS') {
    address = `${address} ${adr.countryCode}`;
  }
  return address;
};

const transformResponse = (res: ICustomerData) => {
  let profile: ICustomerProfile;
  if (res.success) {
    profile = {
      investorName: getInvestorName(res.data, res.data.type as IInvestor),
      residentialAddress: combinedAddress(res.data.address, addressType.residentialAddress),
      postalAddress: combinedAddress(res.data.postAddress, addressType.postalAddress),
      homePhone: res.data.homePhone || nullValueString,
      mobliePhone: res.data.mobilePhone || nullValueString,
      email: res.data.email || nullValueString,
      type: res.data.type.code,
    };
  } else {
    //TODO: Error handler
  }
  return profile;
};

const getCustomerProfile = async () => {
  if (challengerEnv().mockApiResponses) {
    const profile = require('../../cypress/fixtures/profile/mock-profile-response-success.json'); // simulate API with Mock data...
    const formattedCustomer = transformResponse(profile);
    return formattedCustomer;
  }
  else{
    const url = `${challengerEnv().apiBaseUrl}/${customerManagementPath}/investors/obfuscated`;
    const customerDetail = await get(url);
    const formattedCustomer = transformResponse(customerDetail as ICustomerData);
    return formattedCustomer;
  }
};

const getInvestorName = (profile: ICustomerProfileResponse, investorType: IInvestor) => {
  if (investorType.code === InvestorType.personalInvestor) {
    return `${profile.firstName || ''} ${profile.lastName || ''}`;
  }
  return profile.companyName;
};

const getMockResponse = function (response) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(response), Math.random() * 3000);
  });
};

export { contactRequest, getCustomerProfile, combinedAddress, addressType };
